import React from "react";
import { AlertTriangle, Info, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export type GameNotification = {
  id: string;
  title: string;
  message: string;
  type: 'info' | 'warning' | 'error';
  timeout?: number;
};

interface GameNotificationsProps {
  notifications: GameNotification[];
  removeNotification: (id: string) => void;
}

export const GameNotifications: React.FC<GameNotificationsProps> = ({
  notifications,
  removeNotification
}) => {
  return (
    <div className="fixed top-16 right-4 z-50 w-80 space-y-2 pointer-events-none">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
            className={`pointer-events-auto rounded-lg shadow-lg p-4 ${
              notification.type === 'error' 
                ? 'bg-red-600/90 text-white' 
                : notification.type === 'warning' 
                  ? 'bg-amber-600/90 text-white' 
                  : 'bg-teal-600/90 text-white'
            } flex items-start`}
          >
            <div className="flex-shrink-0 mr-2">
              {notification.type === 'error' ? (
                <AlertTriangle className="h-5 w-5" />
              ) : notification.type === 'warning' ? (
                <AlertTriangle className="h-5 w-5" />
              ) : (
                <Info className="h-5 w-5" />
              )}
            </div>
            <div className="flex-1">
              <h3 className="font-medium">{notification.title}</h3>
              <p className="text-sm opacity-90">{notification.message}</p>
            </div>
            <button
              onClick={() => removeNotification(notification.id)}
              className="flex-shrink-0 ml-2 opacity-80 hover:opacity-100 transition-opacity"
            >
              <X className="h-4 w-4" />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};